import {
  AssessmentId,
  BulkRiskUpdate,
  CreateHumanReviewAction,
  CreateRiskContext,
  OwnerId,
  Risk,
  RiskContext,
  RiskContextId,
  RiskId,
  RiskIdPair,
} from "../../Types";
import {invalidateQueries, q} from "../../state";
import jsonApi from "../jsonApi";

export async function load(riskIds: RiskIdPair[]) {
  return await jsonApi.post<(Risk | null)[]>(`/tprm/risks/load`, riskIds);
}

export async function assign(riskId: RiskId, ownerId: OwnerId | null) {
  const res = await jsonApi.post<"ok">(`/tprm/risks/${riskId}/owner`, ownerId);
  await invalidateQueries([q.tprm.risk.filter()]);
  return res;
}

export async function loadContexts(contextIds: RiskContextId[]) {
  return await jsonApi.post<(RiskContext | null)[]>(`/tprm/risk_contexts/load`, contextIds);
}

export async function addContext(riskId: RiskId, context: CreateRiskContext) {
  const res = await jsonApi.post<RiskContextId>(`/tprm/risks/${riskId}/contexts`, context);
  return res;
}

export async function delete_(riskId: RiskId, assessmentId: AssessmentId) {
  const res = await jsonApi.delete_<"ok">(`/tprm/risks/${riskId}`);
  await invalidateQueries([q.tprm.assessmentRisks.filter(assessmentId), q.tprm.assessmentNodes.filter(assessmentId)]);
  return res;
}

export async function bulkUpdate(update: BulkRiskUpdate) {
  const res = await jsonApi.patch<"ok">(`/tprm/risks`, update);
  await invalidateQueries([q.tprm.assessmentRisks.filter(), q.tprm.assessment.filter(), q.tprm.risk.filter()]);
  return res;
}

export async function createHumanReviews(riskId: RiskId, requests: CreateHumanReviewAction[]) {
  const res = await jsonApi.post<"ok">(`/tprm/risks/${riskId}/human_reviews`, requests);
  await invalidateQueries([q.tprm.assessmentRisks.filter(), q.tprm.assessment.filter(), q.tprm.risk.filter()]);
  return res;
}
